// extracted by mini-css-extract-plugin
export default {"main":"RbKiZ","active":"i4Kbk","content":"GIFji","text":"I9JjJ"};